import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./Checkbox.scss";

const CheckboxLabel = ({ children, id, customClass, ...restProps }) => (
  <span className={cx(styles.ciLabel, customClass)} {...restProps}>
    {children}
  </span>
);

CheckboxLabel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  id: PropTypes.string.isRequired,
  customClass: PropTypes.string,
};

CheckboxLabel.defaultProps = {
  customClass: undefined,
};

CheckboxLabel.displayName = "Checkbox.Label";

export default CheckboxLabel;
